import { routes } from "@bezoned/shared/routes.js";
import {
  Body2,
  Button,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
} from "@fluentui/react-components";

import { env } from "../../utils/env.js";

export const StartSubscription = () => (
  <Card className="mx-auto my-8 max-w-2xl">
    <CardHeader
      className="w-full px-5 py-4"
      header={
        <div className="flex w-full items-center justify-between">
          <div className="text-bzd-gray-400 text-4xl font-normal">
            Get license
          </div>
          <img
            alt="BeZoned logo"
            className="h-12 w-auto"
            height={1063}
            src="/images/bezoned-logo.png"
            width={3451}
          />
        </div>
      }
    />
    <CardPreview className="flex min-h-[250px] flex-col gap-2 px-8 pb-8">
      <Body2 block>You need a BeZoned license to continue.</Body2>
      <Body2 block>
        If your company has already purchased licenses for BeZoned, then ask
        your admin to assign one to you and other users.
      </Body2>
      <Body2 block>
        If you have not purchased license, or need more licenses, then click the
        Buy button below.
      </Body2>
    </CardPreview>
    <CardFooter className="px-5 pb-4">
      <div className="flex w-full flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <a
          className="text-bzd-purple-200 text-md underline"
          href={routes.external.bezoned.help}
          rel="noopener"
          target="_blank"
        >
          Need help?
        </a>
        <div className="flex justify-end gap-3">
          <Button
            appearance="secondary"
            as="a"
            href={`${env.PUBLIC_PORTAL_URL}/${routes.portal.dashboard}`}
            size="large"
            target="_blank"
            type="button"
          >
            Assign licenses
          </Button>
          <Button
            appearance="primary"
            as="a"
            href={routes.external.marketplace.teamPlan}
            size="large"
            target="_blank"
          >
            Buy in Microsoft Store
          </Button>
        </div>
      </div>
    </CardFooter>
  </Card>
);
